import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { YearlyResultByWeekReportService } from './yearly-result-by-week-report.service';
import { AreaService } from '../../system/area/area.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-yearly-result-by-week-report',
  standalone: false,
  templateUrl: './yearly-result-by-week-report.component.html',
  styleUrl: './yearly-result-by-week-report.component.scss'
})
export class YearlyResultByWeekReportComponent {
  title: string = "Yearly Result By Week";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  showSelectedShopOnly: boolean = false;
  showSelectedBranchOnly: boolean = false;
  showSelectedRegionOnly: boolean = false;
  showSelectedAreaMgrOnly: boolean = false;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  shopListData: any = [];
  regionListData: any = [];
  areaMagerListData: any = [];
  brachListData: any = [];
  datePipe: any;
  isExpandedShop = false;
  resetButtonEnabledForShop: boolean = false;
  isExpandedBranch = false;
  resetButtonEnabledForBranch: boolean = false;
  isExpandedRegion = false;
  resetButtonEnabledForRegion: boolean = false;
  resetButtonEnabledForAreaMgr: boolean = false;
  isExpandedAreaMgr = false;
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private yearlyResultByWeekReportService: YearlyResultByWeekReportService,
    private snackBarService: SnackBarService,
    private shopinfoService: ShopinfoService,
    private areaService: AreaService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let uomId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      year: this.builder.control(null),
      filtered_by: this.builder.control('none'),
      sort_order: this.builder.control('store'),
      shopFilterAll: this.builder.control(''),
      shopFilterSelected: this.builder.control(''),
      branchFilterAll: this.builder.control(''),
      brachFilterSelected: this.builder.control(''),
      regionFilterAll: [''],
      regionFilterSelected: [''],
      areaMgrFilterAll: [''],
      areaMgrFilterSelected: [''],


    });

    this.currentYear = new Date().getFullYear();
    this.permission = permissionService.getPagePermission("yearly-result-by-week-hq");
    console.log(this.permission);

  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }


  sortOptions = [
    { value: 'store', label: 'Store' },
    { value: 'branch', label: 'Branch' },
    { value: 'consolidation', label: 'Consolidated' }
  ];





  ngOnInit(): void {
    this.loadData();
    this.shopList();
    this.regionList();
    this.areaMangerList();
    this.branchList();



  }


  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }


  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately




  curFinYear!: string; // Add this to your component properties

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };

  }
  // loadData(): void {

  //   let requestData = this.buildRequestData();
  //   this.yearlyResultByWeekReportService.getWeekNoList(requestData).subscribe(response => {
  //     console.log('API Response:', response);

  //     if (response.status === 'SUCCESS') {
  //       this.financialYears = response.data.finYears;
  //       this.years = this.financialYears.map(fy => fy.year);

  //       // Only set the default value if the form control is empty
  //       if (!this.editForm.get('year')?.value) {
  //         this.curFinYear = response.data.curFinYear;
  //         if (this.curFinYear) {
  //           const yearValue = parseInt(this.curFinYear);
  //           this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

  //           // Set weeks for the current financial year
  //           const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
  //           if (currentFinYear) {
  //             this.weeks = currentFinYear.weeks.map((week: any) => ({
  //               ...week,
  //               displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
  //             }));
  //             // Set the current week as default
  //             const currentWeek = this.getCurrentWeek(this.weeks);
  //             if (currentWeek) {
  //               this.editForm.get('week_no')?.setValue(currentWeek.week_no);
  //             } else if (this.weeks.length > 0) {
  //               // Fallback to first week if current week not found
  //               this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
  //             }
  //           }
  //         }
  //       }

  //       console.log('Financial Years Data:', this.financialYears);
  //     } else {
  //       console.error('API Error:', response.message);
  //     }
  //   });
  // }

  loadData(): void {
    let requestData = this.buildRequestData();
    this.yearlyResultByWeekReportService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.financialYears = response.data.finYears;
        this.years = this.financialYears.map(fy => fy.year);
        this.curFinYear = response.data.curFinYear;
        const currentYearValue = parseInt(this.curFinYear.split('-')[0]);

        // Filter financialYears to include only up to the current year
        this.financialYears = response.data.finYears.filter((fy: any) =>
          fy.year <= currentYearValue
        );
        this.years = this.financialYears.map(fy => fy.year);

        if (!this.editForm.get('year')?.value) {
          const currentYearValue = parseInt(this.curFinYear.split('-')[0]); // Adjust based on curFinYear format
          const currentFinYear = this.financialYears.find(fy => fy.year === currentYearValue);

          if (currentFinYear) {
            this.editForm.get('year')?.setValue(currentYearValue, { emitEvent: false });

            let weeksArray = currentFinYear.weeks;
            const currentWeek = this.getCurrentWeek(weeksArray);

            // Filter weeks if current year
            if (currentWeek) {
              weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
            }

            this.weeks = weeksArray.map((week: any) => ({
              ...week,
              displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
            }));

            // Set current week or first week
            if (currentWeek) {
              this.editForm.get('week_no')?.setValue(currentWeek.week_no);
            } else if (this.weeks.length > 0) {
              this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
            }
          }
        }
      }
    });
  }
  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }



  shopList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "shop.name", order: "ASC" }] } }

    this.shopinfoService.getShopList(requestData).subscribe(
      (response: any) => {
        this.shopListData = [];
        var index = 0;
        response.data.shops.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.shopListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }

  regionList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "name", order: "ASC" }] } }

    this.areaService.getAreaList(requestData).subscribe(
      (response: any) => {
        this.regionListData = [];
        var index = 0;
        response.data.areas.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.regionListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }

  areaMangerList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "name", order: "ASC" }] } }

    this.yearlyResultByWeekReportService.areaManagerList(requestData).subscribe(
      (response: any) => {
        this.areaMagerListData = [];
        var index = 0;
        response.data.managers.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.areaMagerListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }

  branchList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "name", order: "ASC" }] } }

    this.yearlyResultByWeekReportService.branchList(requestData).subscribe(
      (response: any) => {
        this.brachListData = [];
        var index = 0;
        response.data.branches.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.brachListData.push(data);
          index++;
        });

      },
      (error: any) => {

      },
    );
  }



  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  // reset(sourceList: any[]): any {
  //   sourceList.forEach(el => {
  //     el.selected = false;
  //   });
  // }


  onSelectionChange(): void {

  }




  exportClicked(): void {
    this.IsDownloading = true;

    const selectedShopIds = this.shopListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    const selectedRegionIds = this.regionListData
      .filter((region: any) => region.selected)
      .map((region: any) => region.item.id);

    const areaMangerIds = this.areaMagerListData
      .filter((region: any) => region.selected)
      .map((region: any) => region.item.user_id);

    const selectedbrachIds = this.brachListData
      .filter((region: any) => region.selected)
      .flatMap((region: any) => region.item.shopIds);
    console.log(selectedbrachIds)

    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];
    const regionIds = selectedRegionIds.length > 0 ? selectedRegionIds : [];
    const areaMngIds = areaMangerIds.length > 0 ? areaMangerIds : [];
    const brachIds = selectedbrachIds.length > 0 ? selectedbrachIds : [];

    const reportOption = this.editForm.get('sort_order')?.value;
    const filterOption = this.editForm.get('filtered_by')?.value;

    // Default to shopIds
    let filterIds = shopIds;

    // If report is consolidation and filter is region, use regionIds
    if (reportOption === 'consolidation' && filterOption === 'region') {
      filterIds = regionIds;
    }
    if (reportOption === 'consolidation' && filterOption === 'area_manager') {
      filterIds = areaMngIds;
    }
    if (reportOption === 'branch') {
      filterIds = brachIds;
    }

    const reportData = {
      year: this.editForm.get('year')?.value,
      reportOption,
      filterOption,
      filterIds
    };

    if (reportData) {
      this.yearlyResultByWeekReportService.getYtdBranchExportList(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              // Check for no data found status
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check for other error statuses
              if (json.status === 'ERROR' || json.status === 'FAILED') {
                let snackBarData: SnackBarData = {
                  message: json.message || 'An error occurred while generating the report.',
                  title: 'Error!',
                  type: 'error'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // If we reach here with a JSON response, show warning
              let snackBarData: SnackBarData = {
                message: 'Unexpected response format from server.',
                title: 'Warning!',
                type: 'warn'
              }
              this.IsDownloading = false;
              this.snackBarService.openSnackBar(snackBarData);

            } catch (e) {
              // If JSON parsing fails, it's likely a binary file (Excel)
              // Check if the response is empty or very small
              if (response.size === 0) {
                let snackBarData: SnackBarData = {
                  message: 'No data available for export.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check if response is too small to be a valid file
              if (response.size < 100) {
                let snackBarData: SnackBarData = {
                  message: 'No data found for the selected criteria.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Valid binary file - proceed with download
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'Yearly-Result-By-Week-Report.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;

              // Show success message
              let snackBarData: SnackBarData = {
                message: 'Report downloaded successfully.',
                title: 'Success!',
                type: 'success'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.IsDownloading = false;

          let snackBarData: SnackBarData = {
            message: 'An error occurred while fetching the report. Please try again.',
            title: 'Error!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      this.editForm.markAllAsTouched();

      let snackBarData: SnackBarData = {
        message: 'Please fill all required fields.',
        title: 'Validation Error',
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
    }
  }


  selectAll(list: any[]) {
    list.forEach(item => item.selected = true);
    this.isExpandedShop = true;
  }

  reset(list: any[]) {
    list.forEach(item => item.selected = false);
    this.isExpandedShop = true;
  }
  selectAllBranch(list: any[]) {
    list.forEach(item => item.selected = true);
    this.isExpandedBranch = true;
  }

  resetBranch(list: any[]) {
    list.forEach(item => item.selected = false);
    this.isExpandedBranch = true;
  }
  selectAllRegion(list: any[]) {
    list.forEach(item => item.selected = true);
    this.isExpandedRegion = true;
  }

  resetRegion(list: any[]) {
    list.forEach(item => item.selected = false);
    this.isExpandedRegion = true;
  }
  selectAllAreaMgr(list: any[]) {
    list.forEach(item => item.selected = true);
    this.isExpandedAreaMgr = true;
  }

  resetAreaMgr(list: any[]) {
    list.forEach(item => item.selected = false);
    this.isExpandedAreaMgr = true;
  }



  // Shop Helpers
  get filteredShopListData(): any[] {
    const filterValue = this.editForm.get('shopFilterAll')?.value?.toLowerCase() || '';
    let filteredList = this.shopListData;

    if (this.showSelectedShopOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }

    if (filterValue) {
      filteredList = filteredList.filter((item: any) =>
        item.item.name.toLowerCase().includes(filterValue)
      );
    }
    return filteredList;
  }

  toggleSelectAllShop() {
    const allSelected = this.shopListData.every((item: any) => item.selected);
    this.shopListData.forEach((item: any) => (item.selected = !allSelected));
    this.onShopSelectionChange();
  }

  getSelectAllIconShop(): string {
    const allSelected = this.shopListData.every((item: any) => item.selected);
    const someSelected = this.shopListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedShopSourcesCount(): number {
    return this.shopListData.filter((x: any) => x.selected).length;
  }

  updateResetButtonStateForShop(): void {
    // this.resetButtonEnabledForShop = this.shopListData?.some((shop: any) => shop.selected);
  }

  onShopSelectionChange(): void {
    this.updateResetButtonStateForShop();
  }


  // Branch Helpers
  get filteredBranchListData(): any[] {
    const filterValue = this.editForm.get('branchFilterAll')?.value?.toLowerCase() || '';
    let filteredList = this.brachListData;

    if (this.showSelectedBranchOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }

    if (filterValue) {
      filteredList = filteredList.filter((item: any) =>
        item.item.branch.toLowerCase().includes(filterValue)
      );
    }
    return filteredList;
  }

  toggleSelectAllBranch() {
    const allSelected = this.brachListData.every((item: any) => item.selected);
    this.brachListData.forEach((item: any) => (item.selected = !allSelected));
    this.onBrachSelectionChange();
  }

  getSelectAllIconBranch(): string {
    const allSelected = this.brachListData.every((item: any) => item.selected);
    const someSelected = this.brachListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedBranchSourcesCount(): number {
    return this.brachListData.filter((x: any) => x.selected).length;
  }

  updateResetButtonStateForBranch(): void {
    // this.resetButtonEnabledForBranch = this.brachListData?.some((shop: any) => shop.selected);
  }

  onBrachSelectionChange(): void {
    this.updateResetButtonStateForBranch();
  }




  // Region Helpers
  get filteredRegionListData(): any[] {
    const filterValue = this.editForm.get('regionFilterAll')?.value?.toLowerCase() || '';
    let filteredList = this.regionListData;

    if (this.showSelectedRegionOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }

    if (filterValue) {
      filteredList = filteredList.filter((item: any) =>
        item.item.name.toLowerCase().includes(filterValue)
      );
    }
    return filteredList;
  }

  toggleSelectAllRegion() {
    const allSelected = this.regionListData.every((item: any) => item.selected);
    this.regionListData.forEach((item: any) => (item.selected = !allSelected));
    this.onRegionSelectionChange();
  }

  getSelectAllIconRegion(): string {
    const allSelected = this.regionListData.every((item: any) => item.selected);
    const someSelected = this.regionListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedRegionCount(): number {
    return this.regionListData.filter((x: any) => x.selected).length;
  }

  updateResetButtonStateForRegion(): void {
    // this.resetButtonEnabledForRegion = this.regionListData?.some((region: any) => region.selected);
  }

  onRegionSelectionChange(): void {
    this.updateResetButtonStateForRegion();
  }




  // Area Manager Helpers
  get filteredAreaMgrListData(): any[] {
    const filterValue = this.editForm.get('areaMgrFilterAll')?.value?.toLowerCase() || '';
    let filteredList = this.areaMagerListData;

    if (this.showSelectedAreaMgrOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }

    if (filterValue) {
      filteredList = filteredList.filter((item: any) =>
        item.item.name.toLowerCase().includes(filterValue)
      );
    }
    return filteredList;
  }

  toggleSelectAllAreaMgr() {
    const allSelected = this.areaMagerListData.every((item: any) => item.selected);
    this.areaMagerListData.forEach((item: any) => (item.selected = !allSelected));
    this.onAreaMgrSelectionChange();
  }

  getSelectAllIconAreaMgr(): string {
    const allSelected = this.areaMagerListData.every((item: any) => item.selected);
    const someSelected = this.areaMagerListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedAreaMgrCount(): number {
    return this.areaMagerListData.filter((x: any) => x.selected).length;
  }

  updateResetButtonStateForAreaMgr(): void {
    // this.resetButtonEnabledForAreaMgr = this.areaMagerListData?.some((item: any) => item.selected);
  }

  onAreaMgrSelectionChange(): void {
    this.updateResetButtonStateForAreaMgr();
  }


}
